import {
  __export
} from "./chunk-AU4RG7EN.mjs";

// src/definitions/index.ts
var definitions_exports = {};
__export(definitions_exports, {
  FloorViewMode: () => FloorViewMode,
  PinViewMode: () => PinViewMode,
  ProjectFocusMode: () => ProjectFocusMode,
  SpaceFloorViewMode: () => SpaceFloorViewMode
});
var FloorViewMode = /* @__PURE__ */ ((FloorViewMode2) => {
  FloorViewMode2["TWO_DIMENSIONAL"] = "2D";
  FloorViewMode2["DEFAULT"] = "default";
  FloorViewMode2["FIRST_PERSON"] = "firstPerson";
  FloorViewMode2["FLOOR_EDITOR"] = "floorEditor";
  return FloorViewMode2;
})(FloorViewMode || {});
var PinViewMode = /* @__PURE__ */ ((PinViewMode2) => {
  PinViewMode2["EXTERIOR"] = "exterior";
  PinViewMode2["INTERIOR"] = "interior";
  return PinViewMode2;
})(PinViewMode || {});
var SpaceFloorViewMode = /* @__PURE__ */ ((SpaceFloorViewMode2) => {
  SpaceFloorViewMode2["TERRACE"] = "T";
  SpaceFloorViewMode2["MEZZANINE"] = "M";
  SpaceFloorViewMode2["GROUND"] = "G";
  SpaceFloorViewMode2["ALL"] = "all";
  return SpaceFloorViewMode2;
})(SpaceFloorViewMode || {});
var ProjectFocusMode = /* @__PURE__ */ ((ProjectFocusMode2) => {
  ProjectFocusMode2["DEFAULT"] = "default";
  ProjectFocusMode2["BUILDING"] = "building";
  ProjectFocusMode2["FLOOR"] = "floor";
  ProjectFocusMode2["SPACE"] = "space";
  return ProjectFocusMode2;
})(ProjectFocusMode || {});

export {
  FloorViewMode,
  PinViewMode,
  SpaceFloorViewMode,
  ProjectFocusMode,
  definitions_exports
};
